import { createAsyncThunk } from "@reduxjs/toolkit"

import { appLandingPath } from "@/lib/auth-utils"
import { getAppRouter } from "@/lib/router"
import { closeDetailSheetIfTrip } from "./detail-sheet-slice"
import { AppDispatch } from "./redux-store"
import userSlice from "./user-slice"

/**
 * Leaves the active trip chat UI after the user loses access to that trip.
 * Clear Redux first so route synchronization cannot restore the inaccessible
 * chat id while navigation is in progress.
 */
export const exitCurrentTripChat = createAsyncThunk<
  void,
  void,
  { dispatch: AppDispatch }
>("chatExitThunks/exitCurrentTripChat", async (_arg, { dispatch }) => {
  dispatch(userSlice.actions.resetChat())
  await dispatch(closeDetailSheetIfTrip())
  await getAppRouter().replace(appLandingPath())
})
